<div class="container">
  <form [formGroup]="formGroup" (ngSubmit)="handleSubmit()">
    <app-request-title></app-request-title>

    <app-workspace-state
      [workspaceStateDraftVersion]="workspaceStateDraftVersion"
      [workspaceStateId]="workspaceStateId"
      [getWorkspaceStateToSave]="getWorkspaceStateToSave"
      [borderClass]="'card-border-color-from-db'"
      [backgroundClass]="'card-header-color-from-db'"
      [buttonClass]="'btn-color-from-db'"
      (workspaceStateLoaded)="handleLoadWorkspaceResponse($event)"
    ></app-workspace-state>

    @let investorDetailsFormGroupAlertShouldBeVisible =
      submitted && !isInvestorDetailsFormGroupValid();
    <section>
      <div
        class="card mb-4"
        [ngClass]="
          investorDetailsFormGroupAlertShouldBeVisible
            ? 'border-danger border-2'
            : 'card-border-color-from-db'
        "
      >
        <div class="card-header card-header-color-from-db">
          {{ 'MONUMENT_CONSERVATION_GRANT_REQUEST.CLIENT_DATA' | translate }}
        </div>

        <div class="card-body">
          <app-investor-details
            [investorDetailsFromGroup]="getInvestorDetailsFormGroup()"
            [isEmailRequired]="false"
            [isEPUAPAddressVisible]="true"
            [isPeselVisible]="false"
            [isIdVisible]="false"
            [isPhoneNumberRequired]="false"
            [disabledNaturalPersonData]="true"
            [wasFormValidated]="submitted"
            [loggedUserAddressEditableByExternalForm]="true"
          ></app-investor-details>
        </div>

        @if (investorDetailsFormGroupAlertShouldBeVisible) {
          <div class="card-footer">
            <div class="alert alert-danger my-2">
              {{ 'FIELDS_REQUIRED' | translate }}
            </div>
          </div>
        }
      </div>
    </section>

    @let taskNameFormControlAlertShouldBeVisible =
      submitted && !isTaskNameFormControlValid();
    <section>
      <div
        class="card mb-4"
        [ngClass]="
          taskNameFormControlAlertShouldBeVisible
            ? 'border-danger border-2'
            : 'card-border-color-from-db'
        "
      >
        <div class="card-header card-header-color-from-db">
          <label class="mb-0" [attr.for]="controlName.TaskName">
            {{ 'MONUMENT_CONSERVATION_GRANT_REQUEST.TASK_NAME' | translate }}
          </label>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <textarea
                [name]="controlName.TaskName"
                [id]="controlName.TaskName"
                class="form-control form-control-sm required"
                aria-required="true"
                [formControlName]="controlName.TaskName"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="card-footer">
          <p class="text-muted mb-0">
            {{
              'MONUMENT_CONSERVATION_GRANT_REQUEST.TASK_NAME_INFO' | translate
            }}
          </p>
          @if (taskNameFormControlAlertShouldBeVisible) {
            <div class="alert alert-danger my-2">
              {{ 'FIELD_REQUIRED' | translate }}
            </div>
          }
        </div>
      </div>
    </section>

    @let monumentNameFormControlAlertShouldBeVisible =
      submitted && !isMonumentNameFormControlValid();
    <section>
      <div
        class="card mb-4"
        [ngClass]="
          monumentNameFormControlAlertShouldBeVisible
            ? 'border-danger border-2'
            : 'card-border-color-from-db'
        "
      >
        <div class="card-header card-header-color-from-db">
          <label class="mb-0" [attr.for]="controlName.MonumentName">
            {{
              'MONUMENT_CONSERVATION_GRANT_REQUEST.MONUMENT_NAME' | translate
            }}
          </label>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <textarea
                [name]="controlName.MonumentName"
                [id]="controlName.MonumentName"
                class="form-control form-control-sm required"
                aria-required="true"
                [formControlName]="controlName.MonumentName"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="card-footer">
          <p class="text-muted mb-0">
            {{
              'MONUMENT_CONSERVATION_GRANT_REQUEST.MONUMENT_NAME_INFO'
                | translate
            }}
          </p>
          @if (monumentNameFormControlAlertShouldBeVisible) {
            <div class="alert alert-danger my-2">
              {{ 'FIELD_REQUIRED' | translate }}
            </div>
          }
        </div>
      </div>
    </section>

    @let monumentRegistryNumberFormControlAlertShouldBeVisible =
      submitted && !isMonumentRegistryNumberFormControlValid();
    @let monumentDataSectionAlertShouldBeVisible =
      monumentRegistryNumberFormControlAlertShouldBeVisible;
    <section>
      <div
        class="card mb-4"
        [ngClass]="
          monumentDataSectionAlertShouldBeVisible
            ? 'border-danger border-2'
            : 'card-border-color-from-db'
        "
      >
        <div class="card-header card-header-color-from-db">
          {{ 'MONUMENT_CONSERVATION_GRANT_REQUEST.MONUMENT_DATA' | translate }}
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <label
                class="text-nowrap"
                [attr.for]="controlName.MonumentRegistryNumber"
              >
                {{
                  'MONUMENT_CONSERVATION_GRANT_REQUEST.MONUMENT_REGISTRY_NUMBER'
                    | translate
                }}
              </label>
              <input
                type="text"
                [name]="controlName.MonumentRegistryNumber"
                [id]="controlName.MonumentRegistryNumber"
                class="form-control form-control-sm required"
                aria-required="true"
                [formControlName]="controlName.MonumentRegistryNumber"
              />
              @if (monumentRegistryNumberFormControlAlertShouldBeVisible) {
                <div class="alert alert-danger my-2">
                  {{ 'FIELD_REQUIRED' | translate }}
                </div>
              }
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-12">
              <label
                class="text-nowrap"
                [attr.for]="controlName.MonumentRegistryDate"
              >
                {{
                  'MONUMENT_CONSERVATION_GRANT_REQUEST.MONUMENT_REGISTRY_DATE'
                    | translate
                }}
              </label>
              <div class="input-group">
                <input
                  class="form-control form-control-sm"
                  [attr.placeholder]="
                    'GK.DYNAMIC_LIST.DATE_PLACEHOLDER' | translate
                  "
                  [id]="controlName.MonumentRegistryDate"
                  [name]="controlName.MonumentRegistryDate"
                  [formControlName]="controlName.MonumentRegistryDate"
                  ngbDatepicker
                  #monumentRegistryDatePicker="ngbDatepicker"
                />
                <button
                  class="btn btn-outline-secondary fa fa-calendar"
                  (click)="monumentRegistryDatePicker.toggle()"
                  type="button"
                ></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    @let mapSectionAlertShouldBeVisible = submitted && !isMapSectionValid();
    <section>
      <div
        class="card mb-4"
        [ngClass]="
          mapSectionAlertShouldBeVisible
            ? 'border-danger border-2'
            : 'card-border-color-from-db'
        "
      >
        <div class="card-header card-header-color-from-db">
          {{ 'MONUMENT_CONSERVATION_GRANT_REQUEST.MAP_LOCATION' | translate }}
        </div>

        <div class="card-body">
          <gk-map
            [mapState]="mapState"
            (dispatch)="handleMapAction($event)"
          ></gk-map>

          <div class="my-2">
            @if (mapState.mapObjectTablesState[0].mapObjects.length) {
              <gk-map-object-table
                [mapState]="mapState"
                [mapObjectTableStateIndex]="0"
                (dispatch)="handleMapAction($event)"
              ></gk-map-object-table>
            }
          </div>
        </div>
        @if (mapSectionAlertShouldBeVisible) {
          <div class="card-footer">
            <div class="alert alert-danger my-2">
              {{ 'LAND_PARCEL_OR_BUILDING_REQUIRED' | translate }}
            </div>
          </div>
        }
      </div>
    </section>

    <section>
      <div class="card mb-4 card-border-color-from-db">
        <div class="card-header card-header-color-from-db">
          <label class="mb-0" [attr.for]="controlName.DeterminationOfLocation">
            {{
              'MONUMENT_CONSERVATION_GRANT_REQUEST.DETERMINATION_OF_LOCATION'
                | translate
            }}
          </label>
        </div>

        <div class="card-body">
          <textarea
            [name]="controlName.DeterminationOfLocation"
            [id]="controlName.DeterminationOfLocation"
            class="form-control"
            [formControlName]="controlName.DeterminationOfLocation"
          ></textarea>
        </div>
      </div>
    </section>

    @let justificationOfImportanceFormControlAlertShouldBeVisible =
      submitted && !isJustificationOfImportanceFormControlValid();
    <section>
      <div
        class="card mb-4"
        [ngClass]="
          justificationOfImportanceFormControlAlertShouldBeVisible
            ? 'border-danger border-2'
            : 'card-border-color-from-db'
        "
      >
        <div class="card-header card-header-color-from-db">
          <label
            class="mb-0"
            [attr.for]="controlName.JustificationOfImportance"
          >
            {{
              'MONUMENT_CONSERVATION_GRANT_REQUEST.JUSTIFICATION_OF_IMPORTANCE'
                | translate
            }}
          </label>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <textarea
                [name]="controlName.JustificationOfImportance"
                [id]="controlName.JustificationOfImportance"
                class="form-control form-control-sm required"
                aria-required="true"
                [formControlName]="controlName.JustificationOfImportance"
              ></textarea>
            </div>
          </div>
        </div>

        @if (justificationOfImportanceFormControlAlertShouldBeVisible) {
          <div class="card-footer">
            <div class="alert alert-danger my-2">
              {{ 'FIELD_REQUIRED' | translate }}
            </div>
          </div>
        }
      </div>
    </section>

    @let contactPersonFormControlAlertShouldBeVisible =
      submitted && !isContactPersonFormControlValid();
    <section>
      <div
        class="card mb-4"
        [ngClass]="
          contactPersonFormControlAlertShouldBeVisible
            ? 'border-danger border-2'
            : 'card-border-color-from-db'
        "
      >
        <div class="card-header card-header-color-from-db">
          <label class="mb-0" [attr.for]="controlName.ContactPerson">
            {{
              'MONUMENT_CONSERVATION_GRANT_REQUEST.CONTACT_PERSON' | translate
            }}
          </label>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <textarea
                [name]="controlName.ContactPerson"
                [id]="controlName.ContactPerson"
                class="form-control form-control-sm required"
                aria-required="true"
                [formControlName]="controlName.ContactPerson"
              ></textarea>
            </div>
          </div>
        </div>

        @if (contactPersonFormControlAlertShouldBeVisible) {
          <div class="card-footer">
            <div class="alert alert-danger my-2">
              {{ 'FIELD_REQUIRED' | translate }}
            </div>
          </div>
        }
      </div>
    </section>

    @let applicantAccountNumberFormControlRequiredErrorShouldBeVisible =
      shouldShowApplicantAccountNumberFormControlRequiredError();
    @let applicantAccountNumberFormControlIbanErrorShouldBeVisible =
      shouldShowApplicantAccountNumberFormControlIbanError();
    @let applicantAccountNumberFormControlAlertShouldBeVisible =
      applicantAccountNumberFormControlRequiredErrorShouldBeVisible ||
      applicantAccountNumberFormControlIbanErrorShouldBeVisible;
    <section>
      <div
        class="card mb-4"
        [ngClass]="
          applicantAccountNumberFormControlAlertShouldBeVisible
            ? 'border-danger border-2'
            : 'card-border-color-from-db'
        "
      >
        <div class="card-header card-header-color-from-db">
          <label class="mb-0" [attr.for]="controlName.ApplicantAccountNumber">
            {{
              'MONUMENT_CONSERVATION_GRANT_REQUEST.APPLICANT_ACCOUNT_NUMBER'
                | translate
            }}
          </label>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <input
                #applicantAccountNumber
                type="text"
                [name]="controlName.ApplicantAccountNumber"
                [id]="controlName.ApplicantAccountNumber"
                class="form-control required"
                aria-required="true"
                [formControlName]="controlName.ApplicantAccountNumber"
                (input)="
                  onBankAccountInput(
                    $event,
                    getApplicantAccountNumberFormControl()
                  )
                "
              />
            </div>
          </div>
        </div>

        @if (applicantAccountNumberFormControlAlertShouldBeVisible) {
          <div class="card-footer">
            @if (
              applicantAccountNumberFormControlRequiredErrorShouldBeVisible
            ) {
              <div class="alert alert-danger my-2">
                {{ 'FIELD_REQUIRED' | translate }}
              </div>
            }
            @if (applicantAccountNumberFormControlIbanErrorShouldBeVisible) {
              <div class="alert alert-danger my-2">
                {{ 'INVALID_ACCOUNT_NUMBER' | translate }}
              </div>
            }
          </div>
        }
      </div>
    </section>

    @let legalTitleToMonumentFormControlAlertShouldBeVisible =
      submitted && !isLegalTitleToMonumentFormControlValid();
    <section>
      <div
        class="card mb-4"
        [ngClass]="
          legalTitleToMonumentFormControlAlertShouldBeVisible
            ? 'border-danger border-2'
            : 'card-border-color-from-db'
        "
      >
        <div class="card-header card-header-color-from-db">
          <label class="mb-0" [attr.for]="controlName.LegalTitleToMonument">
            {{
              'MONUMENT_CONSERVATION_GRANT_REQUEST.LEGAL_TITLE_TO_MONUMENT'
                | translate
            }}
          </label>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <textarea
                [name]="controlName.LegalTitleToMonument"
                [id]="controlName.LegalTitleToMonument"
                class="form-control form-control-sm required"
                aria-required="true"
                [formControlName]="controlName.LegalTitleToMonument"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="card-footer">
          <p class="text-muted mb-0">
            {{
              'MONUMENT_CONSERVATION_GRANT_REQUEST.LEGAL_TITLE_TO_MONUMENT_INFO'
                | translate
            }}
          </p>
          @if (legalTitleToMonumentFormControlAlertShouldBeVisible) {
            <div class="alert alert-danger my-2">
              {{ 'FIELD_REQUIRED' | translate }}
            </div>
          }
        </div>
      </div>
    </section>

    @let landAndMortgageRegisterNumberAndDocumentsCollectionNumberSectionAlertShouldBeVisible =
      submitted &&
      !isLandAndMortgageRegisterNumberAndDocumentsCollectionNumberFormGroupValid();
    <section
      [formGroup]="
        getLandAndMortgageRegisterNumberAndDocumentsCollectionNumberFormGroup()
      "
    >
      <div
        class="card mb-4"
        [ngClass]="
          landAndMortgageRegisterNumberAndDocumentsCollectionNumberSectionAlertShouldBeVisible
            ? 'border-danger border-2'
            : 'card-border-color-from-db'
        "
      >
        <div class="card-header card-header-color-from-db">
          {{
            'MONUMENT_CONSERVATION_GRANT_REQUEST.PROPERTY_IDENTIFICATION_DOCUMENT_NUMBER'
              | translate
          }}
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-md-6 col-12">
              <label
                class="text-nowrap"
                [attr.for]="
                  landAndMortgageRegisterNumberAndDocumentsCollectionNumberFormControlName.LandAndMortgageRegisterNumber
                "
              >
                {{
                  'MONUMENT_CONSERVATION_GRANT_REQUEST.LAND_AND_MORTGAGE_REGISTER_NUMBER'
                    | translate
                }}
              </label>
              <input
                type="text"
                [name]="
                  landAndMortgageRegisterNumberAndDocumentsCollectionNumberFormControlName.LandAndMortgageRegisterNumber
                "
                [id]="
                  landAndMortgageRegisterNumberAndDocumentsCollectionNumberFormControlName.LandAndMortgageRegisterNumber
                "
                class="form-control form-control-sm"
                aria-required="true"
                [formControlName]="
                  landAndMortgageRegisterNumberAndDocumentsCollectionNumberFormControlName.LandAndMortgageRegisterNumber
                "
              />
            </div>
            <div class="col-md-6 col-12 mt-2 mt-md-0">
              <label
                class="text-nowrap"
                [attr.for]="
                  landAndMortgageRegisterNumberAndDocumentsCollectionNumberFormControlName.DocumentsCollectionNumber
                "
              >
                {{
                  'MONUMENT_CONSERVATION_GRANT_REQUEST.DOCUMENTS_COLLECTION_NUMBER'
                    | translate
                }}
              </label>
              <input
                type="text"
                [name]="
                  landAndMortgageRegisterNumberAndDocumentsCollectionNumberFormControlName.DocumentsCollectionNumber
                "
                [id]="
                  landAndMortgageRegisterNumberAndDocumentsCollectionNumberFormControlName.DocumentsCollectionNumber
                "
                class="form-control form-control-sm"
                aria-required="true"
                [formControlName]="
                  landAndMortgageRegisterNumberAndDocumentsCollectionNumberFormControlName.DocumentsCollectionNumber
                "
              />
            </div>
          </div>
        </div>
        <div class="card-footer">
          @if (
            landAndMortgageRegisterNumberAndDocumentsCollectionNumberSectionAlertShouldBeVisible
          ) {
            <div class="alert alert-danger my-2">
              {{
                'MONUMENT_CONSERVATION_GRANT_REQUEST.PROPERTY_IDENTIFICATION_DOCUMENT_NUMBER_INFO'
                  | translate
              }}
            </div>
          } @else {
            <p class="text-muted mb-0">
              {{
                'MONUMENT_CONSERVATION_GRANT_REQUEST.PROPERTY_IDENTIFICATION_DOCUMENT_NUMBER_INFO'
                  | translate
              }}
            </p>
          }
        </div>
      </div>
    </section>

    <app-mcgr-permit-section
      [submitted]="submitted"
      [formGroup]="getConservationPermitFormGroup()"
      [sectionHeader]="
        'MONUMENT_CONSERVATION_GRANT_REQUEST.PERMIT_SECTION.CONSERVATION_PERMIT_TITLE'
      "
      [idPrefix]="'conservation-'"
    ></app-mcgr-permit-section>

    <app-mcgr-permit-section
      #constructionPermitSection
      [submitted]="submitted"
      [formGroup]="getConstructionPermitFormGroup()"
      [sectionHeader]="
        'MONUMENT_CONSERVATION_GRANT_REQUEST.PERMIT_SECTION.CONSTRUCTION_PERMIT_TITLE'
      "
      [idPrefix]="'construction-'"
    ></app-mcgr-permit-section>

    @let scopeOfWorksFormControlAlertShouldBeVisible =
      submitted && !isScopeOfWorksFormControlValid();
    <section>
      <div
        class="card mb-4"
        [ngClass]="
          scopeOfWorksFormControlAlertShouldBeVisible
            ? 'border-danger border-2'
            : 'card-border-color-from-db'
        "
      >
        <div class="card-header card-header-color-from-db">
          <label class="mb-0" [attr.for]="controlName.ScopeOfWorks">
            {{
              'MONUMENT_CONSERVATION_GRANT_REQUEST.SCOPE_OF_WORKS' | translate
            }}
          </label>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <textarea
                [name]="controlName.ScopeOfWorks"
                [id]="controlName.ScopeOfWorks"
                class="form-control form-control-sm required"
                aria-required="true"
                [formControlName]="controlName.ScopeOfWorks"
              ></textarea>
            </div>
          </div>
        </div>

        @if (scopeOfWorksFormControlAlertShouldBeVisible) {
          <div class="card-footer">
            <div class="alert alert-danger my-2">
              {{ 'FIELD_REQUIRED' | translate }}
            </div>
          </div>
        }
      </div>
    </section>

    @let justificationOfWorksPurposeFormControlAlertShouldBeVisible =
      submitted && !isJustificationOfWorksPurposeFormControlValid();
    <section>
      <div
        class="card mb-4"
        [ngClass]="
          justificationOfWorksPurposeFormControlAlertShouldBeVisible
            ? 'border-danger border-2'
            : 'card-border-color-from-db'
        "
      >
        <div class="card-header card-header-color-from-db">
          <label
            class="mb-0"
            [attr.for]="controlName.JustificationOfWorksPurpose"
          >
            {{
              'MONUMENT_CONSERVATION_GRANT_REQUEST.JUSTIFICATION_OF_WORKS_PURPOSE'
                | translate
            }}
          </label>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <textarea
                [name]="controlName.JustificationOfWorksPurpose"
                [id]="controlName.JustificationOfWorksPurpose"
                class="form-control form-control-sm required"
                aria-required="true"
                [formControlName]="controlName.JustificationOfWorksPurpose"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="card-footer">
          <p class="text-muted mb-0">
            {{
              'MONUMENT_CONSERVATION_GRANT_REQUEST.JUSTIFICATION_OF_WORKS_PURPOSE_INFO'
                | translate
            }}
          </p>
          @if (justificationOfWorksPurposeFormControlAlertShouldBeVisible) {
            <div class="alert alert-danger my-2">
              {{ 'FIELD_REQUIRED' | translate }}
            </div>
          }
        </div>
      </div>
    </section>

    @let worksDateRangeFormControlAlertShouldBeVisible =
      submitted && isWorksDateRangeInvalid();
    <section>
      <div
        class="card mb-4"
        [ngClass]="
          worksDateRangeFormControlAlertShouldBeVisible
            ? 'border-danger border-2'
            : 'card-border-color-from-db'
        "
      >
        <div class="card-header card-header-color-from-db">
          <label class="mb-0" [attr.for]="controlName.WorksDateRange">
            {{
              'MONUMENT_CONSERVATION_GRANT_REQUEST.WORKS_DATE_RANGE' | translate
            }}
          </label>
        </div>

        <div class="card-body">
          <app-date-range-picker
            #worksDateRangeComponent
            (dateRangeChanged)="updateWorksDateRangeFormControl($event)"
            [required]="true"
          ></app-date-range-picker>
        </div>

        @if (worksDateRangeFormControlAlertShouldBeVisible) {
          <div class="card-footer">
            <div class="alert alert-danger my-2">
              {{ 'PERIOD_INVALID' | translate }}
            </div>
          </div>
        }
      </div>
    </section>

    <app-mcgr-financial-sector-application-form-array
      [formGroup]="formGroup"
      [submitted]="submitted"
    ></app-mcgr-financial-sector-application-form-array>

    <app-mcgr-work-estimated-costs
      [formGroup]="getWorksEstimatedCostsFormGroup()"
      [submitted]="submitted"
    ></app-mcgr-work-estimated-costs>

    <section>
      <div class="card card-border-color-from-db mb-4">
        <div class="card-header card-header-color-from-db">
          {{
            'MONUMENT_CONSERVATION_GRANT_REQUEST.MONUMENT_CARE.TITLE'
              | translate
          }}
        </div>

        <div class="card-body">
          <div class="card">
            <div class="card-header">
              <label class="mb-0" [attr.for]="controlName.MonumentCare">
                {{
                  'MONUMENT_CONSERVATION_GRANT_REQUEST.MONUMENT_CARE.MONUMENT_CARE_DETAILS'
                    | translate
                }}
              </label>
            </div>
            <div class="card-body">
              <textarea
                [name]="controlName.MonumentCare"
                [id]="controlName.MonumentCare"
                class="form-control form-control-sm"
                [formControlName]="controlName.MonumentCare"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="card-body">
          <div class="card">
            <div class="card-header">
              {{
                'MONUMENT_CONSERVATION_GRANT_REQUEST.MONUMENT_CARE.MONUMENT_PROTECTION'
                  | translate
              }}
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <mat-checkbox
                    [id]="controlName.HasBuildingBook"
                    [formControlName]="controlName.HasBuildingBook"
                  >
                    {{
                      'MONUMENT_CONSERVATION_GRANT_REQUEST.MONUMENT_CARE.HAS_BUILDING_BOOK'
                        | translate
                    }}
                  </mat-checkbox>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <mat-checkbox
                    [id]="controlName.HasAnnualTechInspections"
                    [formControlName]="controlName.HasAnnualTechInspections"
                  >
                    {{
                      'MONUMENT_CONSERVATION_GRANT_REQUEST.MONUMENT_CARE.HAS_ANNUAL_TECH_INSPECTIONS'
                        | translate
                    }}
                  </mat-checkbox>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <mat-checkbox
                    [id]="controlName.HasFiveYearTechInspections"
                    [formControlName]="controlName.HasFiveYearTechInspections"
                  >
                    {{
                      'MONUMENT_CONSERVATION_GRANT_REQUEST.MONUMENT_CARE.HAS_FIVE_YEAR_TECH_INSPECTIONS'
                        | translate
                    }}
                  </mat-checkbox>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <label class="mb-0" [attr.for]="controlName.OtherActivities">
                    {{
                      'MONUMENT_CONSERVATION_GRANT_REQUEST.MONUMENT_CARE.OTHER_ACTIVITIES'
                        | translate
                    }}
                  </label>
                  <textarea
                    [name]="controlName.OtherActivities"
                    [id]="controlName.OtherActivities"
                    class="form-control form-control-sm"
                    [formControlName]="controlName.OtherActivities"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <app-mcgr-other-conservation-activities-form-array
      [formGroup]="formGroup"
      [submitted]="submitted"
    ></app-mcgr-other-conservation-activities-form-array>

    <app-proxy-details
      #proxyDetails
      [portalId]="portalId"
      [formGroup]="formGroup"
      [submitted]="submitted"
      [addressFormGroupBasedOnSelectControls]="true"
      [multiple]="true"
      [proxyTypeFormControlVisible]="true"
      [borderClass]="'card-border-color-from-db'"
      [backgroundClass]="'card-header-color-from-db'"
      [buttonClass]="'btn-color-from-db'"
    ></app-proxy-details>

    @let expenditureDeclarationFormControlAlertShouldBeVisible =
      submitted && !isExpenditureDeclarationFormControlValid();
    <section>
      <div
        class="card mb-4"
        [ngClass]="
          expenditureDeclarationFormControlAlertShouldBeVisible
            ? 'border-danger border-2'
            : 'card-border-color-from-db'
        "
      >
        <div class="card-header card-header-color-from-db">
          {{
            'MONUMENT_CONSERVATION_GRANT_REQUEST.APPLICANT_DECLARATION_OF_EXPENDITURE_LABEL'
              | translate
          }}
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <mat-checkbox
                [id]="controlName.ExpenditureDeclaration"
                [formControlName]="controlName.ExpenditureDeclaration"
              >
                {{
                  'MONUMENT_CONSERVATION_GRANT_REQUEST.APPLICANT_DECLARATION_OF_EXPENDITURE_VALUE_1'
                    | translate
                }}
                <ol>
                  <li>
                    {{
                      'MONUMENT_CONSERVATION_GRANT_REQUEST.APPLICANT_DECLARATION_OF_EXPENDITURE_VALUE_2'
                        | translate
                    }}
                  </li>
                  <li>
                    {{
                      'MONUMENT_CONSERVATION_GRANT_REQUEST.APPLICANT_DECLARATION_OF_EXPENDITURE_VALUE_3'
                        | translate
                    }}
                  </li>
                </ol>
              </mat-checkbox>
            </div>
          </div>
        </div>

        @if (expenditureDeclarationFormControlAlertShouldBeVisible) {
          <div class="card-footer">
            <div class="alert alert-danger my-2">
              {{ 'FIELD_REQUIRED' | translate }}
            </div>
          </div>
        }
      </div>
    </section>

    @let awarenessAndTruthfulnessDeclarationFormControlAlertShouldBeVisible =
      submitted && !isAwarenessAndTruthfulnessDeclarationFormControlValid();
    <section>
      <div
        class="card mb-4"
        [ngClass]="
          awarenessAndTruthfulnessDeclarationFormControlAlertShouldBeVisible
            ? 'border-danger border-2'
            : 'card-border-color-from-db'
        "
      >
        <div class="card-header card-header-color-from-db">
          {{
            'MONUMENT_CONSERVATION_GRANT_REQUEST.APPLICANT_DECLARATION_OF_AWARENESS_AND_TRUTHFULNESS_LABEL'
              | translate
          }}
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <mat-checkbox
                [id]="controlName.AwarenessAndTruthfulnessDeclaration"
                [formControlName]="
                  controlName.AwarenessAndTruthfulnessDeclaration
                "
              >
                {{
                  'MONUMENT_CONSERVATION_GRANT_REQUEST.APPLICANT_DECLARATION_OF_AWARENESS_AND_TRUTHFULNESS_VALUE'
                    | translate
                }}
              </mat-checkbox>
            </div>
          </div>
        </div>

        @if (
          awarenessAndTruthfulnessDeclarationFormControlAlertShouldBeVisible
        ) {
          <div class="card-footer">
            <div class="alert alert-danger my-2">
              {{ 'FIELD_REQUIRED' | translate }}
            </div>
          </div>
        }
      </div>
    </section>

    <gk-attachments
      [borderClass]="'card-border-color-from-db'"
      [backgroundClass]="'card-header-color-from-db'"
      [buttonClass]="'btn-color-from-db'"
      [portalId]="portalId"
      [submitted]="submitted"
      [requiredPowerOfAttorney]="proxyDetails.detailsVisible"
      [requiredOtherFile]="otherFileRequired"
      [attachmentsInfo]="'MONUMENT_CONSERVATION_GRANT_REQUEST.ATTACHMENTS_INFO'"
    >
    </gk-attachments>

    <app-request-reply-form
      [portalId]="portalId"
      [formGroup]="formGroup"
      [submitted]="submitted"
      [borderClass]="'card-border-color-from-db'"
      [backgroundClass]="'card-header-color-from-db'"
      [buttonClass]="'btn-color-from-db'"
    ></app-request-reply-form>

    <app-request-validation-info
      [shouldShowProvideFieldsAlert]="submitted && !isRequestValid()"
      [errorSubmitMessage]="errorSubmitMessage"
    ></app-request-validation-info>

    <section class="my-2">
      <app-cautions
        [portalId]="portalId"
        [formGroup]="formGroup"
        [submitted]="submitted"
        [borderClass]="'card-border-color-from-db'"
        [backgroundClass]="'card-header-color-from-db'"
        [buttonClass]="'btn-color-from-db'"
      ></app-cautions>
    </section>

    <section>
      <button type="submit" class="btn btn-color-from-db">
        {{ 'MONUMENT_CONSERVATION_GRANT_REQUEST.SUBMIT' | translate }}
      </button>

      <app-request-preview-button
        class="ms-2"
        [buttonClass]="'btn-color-from-db'"
        [getPreviewRequestBody]="getRequestBody"
        [previewRequestUrl]="
          '/api/interesant/wniosek/zgloszenieEksploatacjiPrzydomowejOczyszczalniSciekow/podglad'
        "
      ></app-request-preview-button>

      <app-request-cancel-button></app-request-cancel-button>

      <app-doc-sign-info
        [messageText]="docSignMsgTxt"
        [messageType]="docSignMsgType"
        [docSignUrl]="docSignUrl"
        [docSignPending]="docSignPending"
      ></app-doc-sign-info>

      <div class="mt-2"><app-form-legend></app-form-legend></div>
    </section>
  </form>
</div>

<ng-template #canDeactivateModal let-close="close">
  <div class="modal-header">
    <h4 class="modal-title">
      {{ 'MODAL_CAN_DEACTIVATE.ALERT_TITLE' | translate }}
    </h4>
  </div>

  <div class="modal-body">
    {{ 'MODAL_CAN_DEACTIVATE.DESCRIPTION' | translate }}
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="close(false)">
      {{ 'MODAL_CAN_DEACTIVATE.CANCEL' | translate }}
    </button>

    <button type="button" class="btn btn-primary" (click)="close(true)">
      {{ 'MODAL_CAN_DEACTIVATE.CONFIRM' | translate }}
    </button>
  </div>
</ng-template>
